import { useEffect, useState } from 'react';
import HomeList from '@/pages/Home/components/HomeList';
import HomeContents from '@/pages/Home/components/HomeContents';
import HomeMobileFooter from '@/pages/Home/components/HomeMobileFooter';
import { api } from '@/api/repository/axios';

// 홈 데이터 타입
export interface HomeData {
    cities?: any[];
    notices?: any[];
    jobTasks?: any[];
    subwayLines?: any[];
    topBanners?: Array<{
        id: number;
        title?: string;
        imageUrl: string;
        mobileImageUrl?: string;
        linkUrl?: string;
        displayOrder: number;
    }>;
    welfareChips?: Array<{ label: string; value: string }>;
    hotPosts?: any[];
    todaySeminars?: any[];
}

const Home = () => {
    const [homeData, setHomeData] = useState<HomeData | null>(null);

    useEffect(() => {
        const fetchHomeData = async () => {
            try {
                const response = await api.search.home();
                if (response.result) {
                    setHomeData(response.result);
                }
            } catch (error) {
                console.error('Failed to fetch home data:', error);
            }
        };

        fetchHomeData();
    }, []);

    return (
        <>
            <HomeContents homeData={homeData} />
            <HomeList />
            <HomeMobileFooter homeData={homeData} />
        </>
    );
};

export default Home;